import { handleResponse, handleBlobResponse } from "utils/utils";
import { authService } from "services";

export const notificationsService = {
	getAll,
	getById,
	add,
	update,
	remove,
	addWithAttachments,
	getAttachment,
	addAttachments,
	removeAttachment,
	setLike,
};

// get notifications
function getAll(options) {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
	};

	let query = "?sort=+name";

	if (options) {
		let { q } = options;

		if (q !== undefined) query += "&q=" + q;
	}

	return fetch(`${global.BASE_API}notifications${query}`, requestOptions).then(
		handleResponse
	);
}

// get notification by id
function getById(id) {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
	};

	return fetch(`${global.BASE_API}notifications/${id}`, requestOptions).then(
		handleResponse
	);
}

// add new notification
function add(notification) {
	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
		body: JSON.stringify(notification),
	};

	return fetch(`${global.BASE_API}notifications/`, requestOptions).then(
		handleResponse
	);
}

// update notification
function update(notification) {
	const requestOptions = {
		method: "PUT",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
		body: JSON.stringify(notification),
	};

	return fetch(
		`${global.BASE_API}notifications/${notification.id}`,
		requestOptions
	).then(handleResponse);
}

// remove notification
function remove(id) {
	const requestOptions = {
		method: "DELETE",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
	};

	return fetch(`${global.BASE_API}notifications/${id}`, requestOptions).then(
		handleResponse
	);
}

/**********************************************************************
 ****** ATTACHMENTS
 ***********************************************************************/

function addWithAttachments(formData) {
	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
		body: formData,
	};

	return fetch(`${global.BASE_API}notifications`, requestOptions).then(
		handleResponse
	);
}

// get one attachment by uuid
function getAttachment(notificationId, attachmentId) {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
	};

	return fetch(
		`${global.BASE_API}notifications/${notificationId}/attachments/${attachmentId}`,
		requestOptions
	).then(handleBlobResponse);
}

// update notification with attachments
function addAttachments(id, formData) {
	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
		body: formData,
	};

	return fetch(
		`${global.BASE_API}notifications/${id}/attachments`,
		requestOptions
	).then(handleResponse);
}

// delete attachment from notification
function removeAttachment(notificationId, attachmentId) {
	const requestOptions = {
		method: "DELETE",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
	};

	return fetch(
		`${global.BASE_API}notifications/${notificationId}/attachments/${attachmentId}`,
		requestOptions
	).then(handleResponse);
}

// set like / unlike
function setLike(id, liked = true) {
	const action = liked ? "like" : "unlike";

	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
	};

	return fetch(
		`${global.BASE_API}notifications/${id}/${action}`,
		requestOptions
	).then(handleResponse);
}
